import { TModalStatus } from 'shared/types/modal';
import { TApplicationState } from 'shared/types/redux';

export const getModalStatus = (state: TApplicationState): TModalStatus => {
  return state.modal.modalStatus;
};
